<template>
  <el-dialog
    :visible.sync="isShow"
    width="600px"
    :title="isEdit ? '编辑领队' : '添加领队'"
    :close-on-click-modal="false"
    custom-class="yioks_alert"
  >
    <el-form
      ref="leaderInfo"
      :model="leaderInfo"
      :rules="formRules"
      label-width="120px"
      class="demo-ruleForm">
      <vue-scroll :ops="ops">
        <el-row v-if="!isEdit">
          <el-col :span="20">
            <el-form-item label="当前培训协会" prop="organUuid">
              <el-select v-model.trim="leaderInfo.organUuid"  @change="changeOrg"  style="width: 100%"  placeholder="请选择当前培训协会">
                <el-option
                  v-for="item in selectOrganList"
                  :key="item.organUuid"
                  :value="item.organUuid"
                  :label="item.organShortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="20">
            <el-form-item label="当前培训协会" prop="organUuid">
              <p style="padding-left: 12px">{{leaderInfo.organShortName}}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isEdit">
          <el-col :span="20">
            <el-form-item label="当前培训机构" prop="youthUuid">
              <el-select
                v-model.trim="leaderInfo.youthUuid"
                style="width: 100%"
                placeholder="请选择培训协会后再选择培训机构"
                @change="changeCenter">
                <el-option
                  v-for="item in selectCenterList"
                  :key="item.uuid"
                  :value="item.uuid"
                  :label="item.youthShortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row  v-else>
          <el-col :span="20">
            <el-form-item label="当前培训机构" prop="youthUuid">
              <p style="padding-left: 12px">{{leaderInfo.youthShortName}}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="领队姓名" prop="idName">
              <el-input v-model.trim="leaderInfo.idName" placeholder="请输入领队姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="领队身份证号" prop="idNumber">
              <el-input v-model.trim="leaderInfo.idNumber" :disabled="isEdit" placeholder="请输入领队身份证号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="领队电话" prop="phone">
              <el-input v-model.trim="leaderInfo.phone" placeholder="请输入领队电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="isEdit">
          <el-col :span="20">
            <el-form-item label="领队状态">
              <el-select v-model.trim="leaderInfo.userStatus" style="width: 100%;">
                <el-option
                  v-for="(item, index) in userStatus"
                  :key="index"
                  :label="item.name"
                  :value="item.status"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isEdit">
          <el-col :span="20">
            <el-form-item label="密码" prop="password">
              <el-input v-model.trim="leaderInfo.password" placeholder="请输入将要更改的密码" type="password"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input  v-model.trim="leaderInfo.confirmPassword" placeholder="请输入确认密码" type="password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="上传照片">
          <UploadImg :imgUrl.sync='leaderInfo.headImgUrl '  :avatarUrl.sync="img" />
          <div>支持jpg,jpeg,bmp,gif,png格式上传</div>
        </el-form-item>
      </vue-scroll>

    </el-form>
    <div class="tip" v-if="!isEdit">* 该手机号将作为领队的初始密码，身份证号作为登录帐号</div>
    <div class="dialog_btn_wrap">
      <el-button
        type="primary"
        style="margin-right:.2rem"
        :loading="addbtnLoading"
        @click="addLeaderAccount"
      >确认</el-button>
      <el-button type="danger" @click="isShow = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import storage from '@/utils/storage'
// import { JSEncrypt } from 'jsencrypt'
import JSEncrypt from '@/assets/js/jsencrypt.min.js'
import leader from '@/api/leader'
import rulesMixin from '@/utils/formRules/leader'
import coach from '@/api/coach'
import auth from '@/api/auth'
import { userStatus } from '@/utils/yioks_data'
import { ops } from '@/utils/scrollIndialog'
export default {
  name: 'index',
  components: {
    'UploadImg': () => import('@/components/UploadImg'),
  },
  mixins: [rulesMixin],
  props: {
    addLeader: {
      type: Boolean,
      required: true
    },
    isEdit: {
      type: Boolean,
      required: false
    },
    leader: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      ops,
      userStatus,
      img: '',
      leaderInfo: {
        phone: '',
        squadUuid: '',
        squadShortName: '',
        idName: '',
        idNumber: '',
        organUuid: '',
        youthUuid: '',
        headImgUrl: '',
        password: '',
        confirmPassword: '',
        userStatus: 'EFFECTIVE'
      },
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      addbtnLoading: false,
      selectOrganList: [],
      squadList: [],
      selectCenterList: []
    }
  },
  computed: {
    isShow: {
      get () {
        return this.addLeader
      },
      set (val) {
        this.$emit('update:addLeader', val)
      }
    }
  },
  created () {
    if (this.isEdit) {
      this.formRules.idNumberPass = this.leader.idNumber
      this.formRules.userUuid = this.leader.uuid
    }
    if (Object.keys(this.leader).length > 0) {
      this.leaderInfo = { ...this.leader, password: '', confirmPassword: '' }
    }
    this.getOrgList()
  },
  methods: {
    changeSquad () {
      const { shortName } = this.squadList.find(item => {
        return item.uuid === this.leaderInfo.squadUuid
      })
      this.leaderInfo.squadShortName = shortName
    },
    getOrgList () {
      let request
      let data
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = coach.getCenterListBySystem
        data = ''
      } else if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
        data = this.uuid
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
        data = this.uuid
      }
      request(data).then(res => {
        this.selectOrganList = res
        if (this.selectOrganList.length === 1) {
          this.leaderInfo.organUuid = this.selectOrganList[0].organUuid
          this.leaderInfo.organShortName = this.selectOrganList[0].organShortName
          this.selectCenterList = this.selectOrganList[0].youthList || []
          if (this.selectCenterList.length === 1) {
            this.leaderInfo.youthUuid = this.selectCenterList[0].uuid
            this.leaderInfo.youthShortName = this.selectCenterList[0].youthShortName
            this.squadList = this.selectCenterList.find(item => {
              return item.uuid === this.leaderInfo.youthUuid
            }).squadList || []
            if (this.squadList === 1) {
              this.leaderInfo.squadUuid = this.squadList[0].uuid
              this.leaderInfo.squadShortName = this.squadList[0].shortName
            }
          }
        }
      })
    },
    changeCenter () {
      this.leaderInfo.youthShortName = this.selectCenterList.find(item => {
        return item.uuid === this.leaderInfo.youthUuid
      }).youthShortName
    },
    changeOrg () {
      this.$set(this.leaderInfo, 'youthUuid', '')
      this.$set(this.leaderInfo, 'youthShortName', '')
      if (this.leaderInfo.organUuid) {
        this.leaderInfo.organShortName = this.selectOrganList.find(item => {
          return item.organUuid === this.leaderInfo.organUuid
        }).organShortName
        this.selectCenterList = this.selectOrganList.find(item => {
          return item.organUuid === this.leaderInfo.organUuid
        }).youthList || []
        if (this.selectCenterList.length === 1) {
          this.$set(this.leaderInfo, 'youthUuid', this.selectCenterList[0].uuid)
          this.$set(this.leaderInfo, 'youthShortName', this.selectCenterList[0].youthShortName)
        }
      } else {
        this.selectCenterList = []
      }
    },
    addLeaderAccount () {
      this.$refs['leaderInfo'].validate(async valid => {
        if (valid) {
          this.addbtnLoading = true
          let requestName = leader.addLeader
          let requestData = {
            leader: {
              youthShortName: this.leaderInfo.youthShortName,
              youthUuid: this.leaderInfo.youthUuid,
              organShortName: this.leaderInfo.organShortName,
              organUuid: this.leaderInfo.organUuid
            },
            userForm: {
              phone: this.leaderInfo.phone,
              idName: this.leaderInfo.idName,
              idNumber: this.leaderInfo.idNumber,
              headImgUrl: this.leaderInfo.headImgUrl
            }
          }
          if (this.isEdit) {
            requestName = leader.updateLeader
            requestData.leader.uuid = this.leaderInfo.uuid
            requestData.userForm.userStatus = this.leaderInfo.userStatus
            if (this.leaderInfo.password) {
              let username = this.leaderInfo.idNumber
              // // ras 加密
              let publicKey = await auth.getPublicKey(username)
              let encryptor = new JSEncrypt()
              encryptor.setPublicKey(publicKey)
              let rsaPassword = encryptor.encrypt(this.leaderInfo.password)
              requestData.userForm.password = rsaPassword
            }
          }
          requestName(requestData).then(res => {
            this.addbtnLoading = false
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$emit('hideLeaderDialog', false)
            }
          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }
      })
    },
  }
}
</script>

<style scoped lang="stylus">
  .demo-ruleForm
    height 500px
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>
